// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-generators-landing-page-generator-js": () => import("./../../../src/generators/landingPageGenerator.js" /* webpackChunkName: "component---src-generators-landing-page-generator-js" */),
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */)
}

